
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

var $2b6bc192fad364d2$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"bbnaa\",\"GlobalFeedbackCollector.fa362290.js\",\"6KGrg\",\"EmojiComponent.6a24c3fe.js\",\"ffEVr\",\"vendors~editor_icon.3082a22f.js\",\"kjZZD\",\"vendors~editor_icon-object.e97fc136.js\",\"ffEVr\",\"vendors~editor_icon.3082a22f.js\",\"iPz8n\",\"GlobalFeedbackCollector.429b0000.js\",\"1RolH\",\"EmojiPickerComponent.54ab340a.js\",\"aHE9G\",\"vendors~editor_atlaskit.00b67b06.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.38039774.js\",\"etwBB\",\"activity.d3402161.js\",\"a2rZD\",\"custom.fc3cd725.js\",\"ePm95\",\"flags.40431f78.js\",\"kJcWg\",\"food.473b199a.js\",\"cUIjD\",\"frequent.67753c39.js\",\"4tIwu\",\"nature.96f73db7.js\",\"1sEV4\",\"objects.ee88e397.js\",\"6Tafs\",\"people.9a055314.js\",\"6j8nK\",\"symbols.fdc6ed64.js\",\"i1sL7\",\"travel.5460db1e.js\",\"36ctu\",\"productivity.bb738ebf.js\",\"bEnB5\",\"modal.74fde4f3.js\",\"fhU7k\",\"esm.50a6c5c3.js\",\"4hOv8\",\"esm.bc27d7ff.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.38039774.js\",\"6ZETc\",\"smart-link.587c04b9.js\",\"ioQ4q\",\"FullPageEditorComponent.10e2e2aa.js\",\"8uCqk\",\"FullPageEditorComponent.runtime.612fb052.js\",\"8uCqk\",\"FullPageEditorComponent.runtime.612fb052.js\",\"1lvsb\",\"EmojiTitlePopover.91f111d1.js\",\"9Zd2C\",\"EmojiTitleButton.40c89c4b.js\",\"dGk3x\",\"GlobalFeedbackCollector.5c3e76a5.js\",\"6gqpV\",\"GlobalFeedbackCollector.493c1808.js\",\"aZinD\",\"vendors.039e293c.js\",\"c6MKV\",\"stable_vendors.37f43bb6.js\",\"cyGuT\",\"feedback-collector.b1919a90.js\",\"aHE9G\",\"vendors~editor_atlaskit.00b67b06.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.38039774.js\",\"aZinD\",\"vendors.039e293c.js\",\"c6MKV\",\"stable_vendors.37f43bb6.js\",\"8Khwy\",\"GlobalFeedbackCollector.7c1b47d5.js\",\"XgRtr\",\"EmojiPicker.957ee883.js\",\"2F69B\",\"vendors~small-pkgs.d41ed4b0.js\",\"4hZJd\",\"EmojiTitleSelection.95a0b4f4.js\",\"hUvv7\",\"LiveDocsDefaultIcon.2e1b14cc.js\"]"));


//# sourceMappingURL=GlobalFeedbackCollector.runtime.397603d3.js.map
